module.exports = __webpack_public_path__ + "img/VRL_Logo_Black.8341c892.png";